import { SVGProps } from "react";

const TrophyIcon = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden={true}
    {...props}
  >
    <path
      d="M13.4497 17.7181C13.4497 15.7852 14.8993 14.7383 17.2349 13.2081C20.1342 11.2752 23.6778 8.9396 23.6778 3.30201C23.6778 2.81879 23.2752 2.41611 22.7114 2.41611H18.2013C17.557 1.20805 15.7047 0 11.8389 0C7.97315 0 6.1208 1.28859 5.47651 2.41611H0.966443C0.483221 2.41611 0 2.81879 0 3.30201C0 8.9396 3.62416 11.3557 6.44295 13.2081C8.77852 14.7383 10.2282 15.7852 10.2282 17.7181V19.4094C7.73154 19.651 5.95973 20.6175 5.95973 21.6644C5.95973 22.953 8.53691 24 11.8389 24C15.0604 24 17.7181 22.953 17.7181 21.6644C17.7181 20.5369 15.8658 19.651 13.4497 19.4094V17.7181ZM17.1544 11.1141C17.8792 9.50336 18.5235 7.4094 18.604 4.18792H21.906C21.5839 7.81208 19.4094 9.58389 17.1544 11.1141ZM11.9195 1.5302C15.5436 1.5302 16.9127 2.97987 16.9127 3.54362C16.9127 4.10738 15.5436 5.55705 11.9195 5.55705C8.2953 5.55705 6.92617 4.10738 6.92617 3.54362C6.92617 3.0604 8.37584 1.5302 11.9195 1.5302ZM2.01342 4.26846H5.31544C5.39597 7.4094 6.04027 9.58389 6.7651 11.1946C4.42953 9.58389 2.33557 7.81208 2.01342 4.26846Z"
      fill="#FFB500"
    />
  </svg>
);

export default TrophyIcon;
